"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAutogeneratedTrailerEnabled = exports.isWixCodeSEOEnabled = exports.isPrivateGraphAPIEnabled = exports.isGraphAPIEnabled = exports.getExperiments = exports.experimentsStore = void 0;
var ExperimentsStore = /** @class */ (function () {
    function ExperimentsStore() {
        this.experiments = {};
    }
    ExperimentsStore.prototype.get = function () {
        return this.experiments;
    };
    ExperimentsStore.prototype.set = function (experiments) {
        this.experiments = experiments;
    };
    return ExperimentsStore;
}());
var isEnabled = function (experiment) { return function () {
    return (0, exports.getExperiments)()[experiment] === 'true';
}; };
exports.experimentsStore = new ExperimentsStore();
var getExperiments = function () { return exports.experimentsStore.get(); };
exports.getExperiments = getExperiments;
exports.isGraphAPIEnabled = isEnabled('specs.vod.useV3GraphAPIPublic');
exports.isPrivateGraphAPIEnabled = isEnabled('specs.vod.useGraphAPI');
var isWixCodeSEOEnabled = function () {
    return isEnabled('specs.vod.wixCodeSEO')() && (0, exports.isGraphAPIEnabled)();
};
exports.isWixCodeSEOEnabled = isWixCodeSEOEnabled;
exports.isAutogeneratedTrailerEnabled = isEnabled('specs.vod.IsAutogeneratedTrailerEnabled');
//# sourceMappingURL=experiments.js.map